<!-- mainSlideWrap -->
<div class="mainSlideWrap">
    <div class="mainVisual swiper">
        <div class="swiper-container">
            <ul class="swiper-wrapper">
                <li class="swiper-slide" *ngFor="let item of (isMobile ? contentMobile : contentPC) ">
                    <a href="#none">
                        <div class="visPc" *ngIf="item.pathKind === 'PC' || item.pathKind === 'ALL'">
                            <img data-sizes="auto" data-src="{{ urlWownet + item.filePath + item.fileName }}" onerror="this.src='./assets/img/noImage.jpg'" class="lazyload" />
                        </div>
                        <div class="visMobi" *ngIf="item.pathKind === 'MOBILE' || item.pathKind === 'ALL'">
                            <img data-sizes="auto" data-src="{{ urlWownet + item.filePath + item.fileName }}" onerror="this.src='./assets/img/noImage.jpg'" class="lazyload" />
                        </div>
                    </a>
                </li>
            </ul>
            <ul class="swiper-pagination"></ul>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
    </div>
</div>
<!-- //mainSlideWrap -->

